export function parseFuncionDate(fecha: string | undefined, hora: string | undefined): { day: string, month: string, timeShow: string, timePuertas: string, dayOfWeek: string } {
    let day = "11";
    let month = "Marzo";
    let timeShow = "21:00 hs";
    let timePuertas = "19:00 hs";
    let dayOfWeek = "Mié";

    if (fecha) {
        const [yearStr, monthStr, dayStr] = fecha.split('-');
        day = dayStr;

        const dateObj = new Date(parseInt(yearStr, 10), parseInt(monthStr, 10) - 1, parseInt(dayStr, 10));
        const daysOfWeek = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
        dayOfWeek = daysOfWeek[dateObj.getDay()];

        const monthNames = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];
        month = monthNames[parseInt(monthStr, 10) - 1];

        if (hora) {
            const [hourStr, minStr] = hora.split(':');
            timeShow = `${hourStr}:${minStr} hs`;

            const hourInt = parseInt(hourStr, 10);
            const puertasHour = hourInt >= 2 ? hourInt - 2 : 24 + (hourInt - 2);
            timePuertas = `${puertasHour.toString().padStart(2, '0')}:${minStr} hs`;
        }
    }

    return { day, month, timeShow, timePuertas, dayOfWeek };
}
